import { ProductApiModel } from './ProductModel';

export const AllDeal: Readonly<AgreementApiModel> = { id: 'all' };

export interface AgreementApiModel {
  id: string;
  enabled?: boolean;
  dealName?: string;
  created?: string;
  agreementType?: string;
  hidden?: boolean;
  reseller?: boolean;
  channelEngagement?: boolean;
  lastUpdated?: string;
  paymentArrangement?: string;
  totalRedeemed?: number;
  isAdmin?: boolean;
  totalUsersRegistered?: number;
  totalSpend?: number;
  totalSavings?: number;
  totalProductsRedeemed?: number;
  expiration?: string;
  products?: ProductApiModel[];
  groups?: DealGroupApiModel[];
  primaryContact?: PrimaryContactApiModel;
  purchaseOrder?: string;
  zones?: string[];
  //  removed later once API is available
  isExpired?: boolean;
  isPayByUser?: boolean;
}

export interface DealGroupApiModel {
  id: string;
  name: string;
  created: string;
  createdByPersonId: number;
  createdByPersonName: string;
  products: ProductApiModel[];
}

export interface PrimaryContactApiModel {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}

export enum DealStatus {
  Active = 0,
  Inactive = 1,
  Expired = 2,
  All = 3,
}

export interface DealOverview {
  accountId: string;
  dealName: string;
  enabled: boolean;
  hidden: boolean;
  id: string;
  expiration: string;
  paymentArrangement: string;
}

export interface NewDealNotification {
  Id: string;
  DealCode: string;
  AccountNumber: string;
}
